// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DgY_","toggleWrap":"styles_toggleWrap__On0DH","content":"styles_content__1LcxP","selectAreaCode":"styles_selectAreaCode__3tIgk"};